import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-generic-date',
    templateUrl: './generic-date.component.html',
    styleUrls: ['./generic-date.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericDateComponent implements OnInit {
  @Input() filter: InternalFilterGroup;
  dataToView: FilterItem[] = [];
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filter) {
      this.dataToView = UtilityFunctions.DeepClone(this.filter.data);
    }
  }

}
